
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_SCORES(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.SCORES, name: name, contents: [] };
  cat.contents = [
    BH.label(name),
    BH.action("SCORE_INIT", "Score initialisieren", "await RAGAI.SCORE.waitForInitials(); \n"),
    { kind: 'label', text: 'Einfacher Score' },
    BH.withNested(
      BH.action("SCORE_ACHIEVE", "Score: Achivement erfüllt\nWert: {{value[@check:Number]}}\nSkill deaktivieren:{{skillId[@check=SKILL]}}\nNachricht: {{msg}}\nautom. Benachrichtigung: {{autoMsg:dropdown=Ja|true,Nein|false}}", "RAGAI.SCORE.achieve({{value}}, {{skillId}}, {{msg}}, {{autoMsg}}); \n", true),
      [
        { forValue: "skillId", isShadow: true, targetBlockType: 'BLOCK_STACK_SKILL' },
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } },
        { forValue: 'msg', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.action("SCORE_RESET", "Score: Zurücksetzen", "RAGAI.SCORE.reset(); \n"),
    BH.withNested(
      BH.action("SCORE_ADD", "Score: Wert erhöhen {{value[@check:Number]}}", "RAGAI.SCORE.add({{value}}); \n", true),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } }]
    ),
    BH.withNested(
      BH.action("SCORE_SUB", "Score: Wert verringern {{value[@check:Number]}}", "RAGAI.SCORE.sub({{value}}); \n", true),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } }]
    ),
    BH.withNested(
      BH.action("SCORE_SET", "Score: Wert setzen {{value[@check:Number]}}", "RAGAI.SCORE.set({{value}}); \n", true),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } }]
    ),
    BH.propertyDropdown("SCORE_ACHIVEMENTS", "Score: Hole Achivements als", [
      ["JSON", "RAGAI.SCORE.getAchieveMents(true)"],
      ["Text", "RAGAI.SCORE.getAchieveMents(false)"]
    ]),
    BH._custom("SCORE_GET", "@output:Number\nScore: Hole Wert", "RAGAI.SCORE.get()", { colour: BLOCKLY_COLORS.PROPERTIES, inputsInline: true }),
    { kind: 'label', text: 'Komplexe Score-Datenbank' },
    BH.withNested(
      BH.action("SCORE_DB_ACHIEVE", "Score {{db}}: Achivement erfüllt\nWert: {{value[@check:Number]}}\nSkill deaktivieren:{{skillId[@check=SKILL]}}\nNachricht: {{msg}}\nautom. Benachrichtigung: {{autoMsg:dropdown=Ja|true,Nein|false}}", "RAGAI.SCORE.db({{db}}).achieve({{value}}, {{skillId}}, {{msg}}, {{autoMsg}}); \n", true),
      [
        { forValue: "skillId", isShadow: true, targetBlockType: 'BLOCK_STACK_SKILL' },
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } },
        { forValue: 'msg', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING },
        { forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.withNested(BH.action("SCORE_DB_RESET", "Score {{db}}: Zurücksetzen", "RAGAI.SCORE.db({{db}}).reset(); \n", true), [{ forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]),
    BH.withNested(
      BH.action("SCORE_DB_ADD", "Score {{db}}: Wert erhöhen {{value[@check:Number]}}", "RAGAI.SCORE.db({{db}}).add({{value}}); \n", true),
      [
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } },
        { forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.withNested(
      BH.action("SCORE_DB_SUB", "Score {{db}}: Wert verringern {{value[@check:Number]}}", "RAGAI.SCORE.db({{db}}).sub({{value}}); \n", true),
      [
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } },
        { forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.withNested(
      BH.action("SCORE_DB_SET", "Score {{db}}: Wert setzen {{value[@check:Number]}}", "RAGAI.SCORE.db({{db}}).set({{value}}); \n", true),
      [
        { forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } },
        { forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }
      ]
    ),
    BH.withNested(BH._custom("SCORE_DB_ACHIVEMENTS", "@output:Number\nScore {{db}}: Hole Achivements als {{json:dropdown=JSON|true,Text|false}}", "RAGAI.SCORE.db({{db}}).getAchieveMents({{json}})", { colour: BLOCKLY_COLORS.PROPERTIES, inputsInline: true }), [{ forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }]),
    BH.withNested(BH._custom("SCORE_DB_GET", "@output:Number\nScore {{db}}: Hole Wert", "RAGAI.SCORE.db({{db}}).get()", { colour: BLOCKLY_COLORS.PROPERTIES, inputsInline: true }), [{ forValue: 'db', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING }])
  ];

  return cat;
}
